import { Component, OnInit } from '@angular/core';
import { UsersService } from 'src/app/services/users/users.service';
import { AuthenticationService } from '../../services/authentincation.service';

@Component({
	selector: 'app-header-user',
	templateUrl: './header-user.component.html',
	styleUrls: [ './header-user.component.scss' ]
})
export class HeaderUserComponent implements OnInit {
    initials: any;

	constructor(private authenticationService: AuthenticationService, private usersService: UsersService) {}

	ngOnInit(): void {
		const t = this;
		this.usersService.getPatient().subscribe((data: any) => {

			if (data.name) {
				const fullName = data.name.split(' ');
				t.initials = fullName.shift().charAt(0) +'.' + fullName.pop().charAt(0) + '.';
			}
		});
	}

	classApplied = false;
	toggleClass() {
		this.classApplied = !this.classApplied;
	}

	classApplied2 = false;
	toggleClass2() {
		this.classApplied2 = !this.classApplied2;
	}

	classApplied3 = false;
	toggleClass3() {
		this.classApplied3 = !this.classApplied3;
	}

	logout() {
		const token = localStorage.getItem('token');
		console.log(token);
		this.authenticationService.logout(token).subscribe((data: any) => {
			localStorage.removeItem(token);
			window.location.reload();
		});
	}
}
